// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".checkout-hot-box .checkout-hot-radio[data-v-4673aa49]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between}.hot-title[data-v-4673aa49]{color:#333;font-size:14px;font-family:PingFang SC-Regular,PingFang SC;font-weight:400}", ""]);
// Exports
module.exports = exports;
